<template>
    <b-row>
        <b-col sm="12">
            <b-card body-class="py-2">
              <section class="list-view-heading">
                <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
                <div class="list-view-heading__controls">
                  <div class="list-view-heading__actions"><TabHeaderActions /></div>
                  <div class="list-view-heading__controls-end">
                    <AccountingHelp view="settings" />
                  </div>
                </div>
              </section>
            </b-card>

            <b-card header-tag="header" footer-tag="footer" no-body>
                <b-row>
                    <b-col>      
                        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
                            <b-tab title="Mis Empresas" :active="tabs.business" @click="setActiveTab('business')">
                                <tab-business></tab-business>
                            </b-tab>
                            <b-tab title="Cuentas Contables Por Defecto" :active="tabs.accountingSettings" @click="setActiveTab('accountingSettings')">
                                <tab-accountingSettings></tab-accountingSettings>
                            </b-tab>
                        </b-tabs>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
    import AccountingHelp from './inc/AccountingHelp'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
    import Profiles from '@/config/profiles'
    import Modules from '@/config/modules'
    import Helper from '@/handler/helper' 
    import Storage from '@/handler/storageLocal'
    import TabBusiness from '@/components/inc/myBusiness/business'
    import TabAccountingSettings from './settings/accountingSettings'

    export default {
        components: {
            AccountingHelp,
            TabHeaderActions,
            TabBusiness,
            TabAccountingSettings
        },
        data: () => {
            return {      
                access: {
                    module_id: Modules.CONTABILIDAD,
                    profile_id: Profiles.PERSONAL,
                    view_reference: 'settings',
                    elements: {}
                },
                tabs: {
                    business: false,
                    accountingSettings: false,
                }
            }
        },
        created () {     
            /* Configurar permisos de vistas y elementos */
            Helper.hasAccessView(this.access)
            /* Fin configuracion */
        }, 
        mounted () {
            this.restoreStatusTabsStorage()
        },
        methods: {
            linkClass(idx) {
                if (this.tabIndex === idx) {
                    return ['bg-primary', 'text-light']
                } else {
                    return ['bg-light', 'text-info']
                }
            },

            //TABS
            disableAllTabs() {
                this.tabs.business = false
                this.tabs.accountingSettings = false
            },
            setActiveTab(value) {
                this.disableAllTabs()

                switch (value) {
                    case 'business':
                        this.tabs.business = true
                        break;        

                    case 'accountingSettings':
                        this.tabs.accountingSettings = true
                        break;        

                    default:
                        this.tabs.business = true
                        break;
                }

                this.saveStatusTabsStorage()
            },

            // FILTROS SAVE
            saveStatusTabsStorage() {
                Storage.setValue('tabs_view_accounting', JSON.stringify(this.tabs))
            },
            restoreStatusTabsStorage() {
                if(Storage.getValue('tabs_view_accounting')) {
                this.tabs = JSON.parse(Storage.getValue('tabs_view_accounting'))
                }         
            },
        } 
    }
</script>